import { render, staticRenderFns } from "./home-data-block.vue?vue&type=template&id=c49414a4&"
import script from "./home-data-block.vue?vue&type=script&lang=ts&"
export * from "./home-data-block.vue?vue&type=script&lang=ts&"
import style0 from "./home-data-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports